import { type FC } from "react";

import { ColoredLabel } from "widgets";

import { getVariantEffectColor } from "../../../../app-utils/color.js";
import { type IAgGridCellProps } from "../cell-base-interfaces.js";
import { TableCell } from "./core/TableCell.js";

export const getVariantEffectDisplayValue = (effect: string) => {
  return <ColoredLabel color={getVariantEffectColor(effect)}>{effect}</ColoredLabel>;
};

const VariantEffectCell: FC<IAgGridCellProps> = (props) => {
  if (!props.value) {
    return null;
  }

  return <TableCell>{getVariantEffectDisplayValue(props.value)}</TableCell>;
};

export default VariantEffectCell;
